var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('small',{staticClass:"uk-text-muted"},[_vm._v(" "+_vm._s(_vm.eanText)+": "),_c('span',{staticClass:"uk-text-uppercase"},[_vm._v(_vm._s(_vm.itemnumber))])])
}
var staticRenderFns = []

export { render, staticRenderFns }